import { ELocalStorageKeys } from '@shared/models/localstorage/localstorage.model'

export type CheckinFlow = 'new' | 'legacy'

const KEY = ELocalStorageKeys.checkinFlow

// Returns the remembered flow; with nothing stored, an invalid value or a failing storage the default is the legacy flow
export function readCheckinFlow(): CheckinFlow {
	try {
		return localStorage.getItem(KEY) === 'new' ? 'new' : 'legacy'
	} catch (error) {
		console.error('readCheckinFlow', 'Storage unavailable, using the legacy flow', error)
		return 'legacy'
	}
}

// The choice lives in localStorage on purpose: it survives reloads and new tabs
export function saveCheckinFlow(flow: CheckinFlow): void {
	try {
		localStorage.setItem(KEY, flow)
	} catch (error) {
		// Best effort: the in-memory state still applies, but a reload falls back to the legacy flow
		console.error(
			'saveCheckinFlow',
			'Storage unavailable, the choice will not survive a reload',
			error
		)
	}
}
